import { useState, useContext } from 'react';
import { Text, Show } from '@chakra-ui/react';
import { CbAlertBanner, CbButton, CbLink } from 'ui/components';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { VerifyEmailModal } from './VerifyEmailModal';
import { AppContext } from 'providers';
import arcadeApiClient from '../../apiClients/arcadeApiClient';
interface RequiresVerificationBannerProps {
  email: string;
  onEmailVerified: () => void;
}
export const RequiresVerificationBanner = ({
  email,
  onEmailVerified
}: RequiresVerificationBannerProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    setToast
  } = useContext(AppContext);
  const handleVerifyEmail = () => {
    arcadeApiClient.put('/multi_platform/users/send_verification').catch(() => {
      setToast({
        status: 'error',
        description: 'Failed to send verification code. Please try again.'
      });
    });
    setIsModalOpen(true);
  };
  return <>
      <CbAlertBanner bannerId="low-tokens" color="var(--chakra-colors-bandicoot-500)" dismissable={false} data-sentry-element="CbAlertBanner" data-sentry-source-file="RequiresVerificationBanner.tsx">
        <Text data-sentry-element="Text" data-sentry-source-file="RequiresVerificationBanner.tsx">
          {'Your email is not verified. Verify your email to access everything Arcade has to offer. '}
          <Show below="sm" data-sentry-element="Show" data-sentry-source-file="RequiresVerificationBanner.tsx">
            <CbLink color="white" textDecoration="underline" onClick={handleVerifyEmail} whiteSpace="nowrap" cursor="pointer" data-sentry-element="CbLink" data-sentry-source-file="RequiresVerificationBanner.tsx">
              {'Verify Email'}
            </CbLink>
          </Show>
        </Text>
        <Show above="sm" data-sentry-element="Show" data-sentry-source-file="RequiresVerificationBanner.tsx">
          <CbButton variant="ghost-on-dark" onClick={handleVerifyEmail} data-sentry-element="CbButton" data-sentry-source-file="RequiresVerificationBanner.tsx">
            <ICON_BY_NAME.email marginRight={2} data-sentry-element="unknown" data-sentry-source-file="RequiresVerificationBanner.tsx" />
            {'Verify Email'}
          </CbButton>
        </Show>
      </CbAlertBanner>
      <VerifyEmailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} email={email} onEmailVerified={onEmailVerified} data-sentry-element="VerifyEmailModal" data-sentry-source-file="RequiresVerificationBanner.tsx" />
    </>;
};